/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

export default baseLodash;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseLodash.js
// module id = 196
// module chunks = 0